// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Unscramble from "../Unscramble/index.js";
var SiteId = function (x) {
    return x;
};
var udecodeSiteId = Unscramble.decodeInt1;
var showSiteId = Data_Show.showInt;
var ordSiteId = Data_Ord.ordInt;
var newtypeSiteId = {
    Coercible0: function () {
        return undefined;
    }
};
var eqSiteId = Data_Eq.eqInt;
var encodeSiteId = Foreign_Generic_Class.intEncode;
var decodeSiteId = Foreign_Generic_Class.intDecode;
export {
    SiteId,
    newtypeSiteId,
    showSiteId,
    eqSiteId,
    ordSiteId,
    encodeSiteId,
    decodeSiteId,
    udecodeSiteId
};
